import React, {useEffect, useState} from 'react';
import {Card, Col, Flex, Row} from "antd";
import CategoryCard from "./CategoryCard";
import style from './Category.module.scss'
import {CategoryListProps} from "../../models";
import {connect} from "react-redux";
import {getProductCategoryList} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import {useNavigate} from "react-router-dom";
import categoryList from "../../../../shared/assets/categoryList";


const CategoryList = ({getProductCategoryList}:CategoryListProps) => {
    const navigate =useNavigate()


    return (
        <Flex vertical gap={"small"}>
            <Row justify={"space-between"}>
                <span className={style.CategoryTitle}>دنبال چه چیزی میگردید ؟</span>
                <small className={style.moreBtn} onClick={() => navigate("/category-list")}> مشاهده همه</small>
            </Row>
            <Flex wrap={"wrap"} justify={"space-between"} gap={"small"}>
                {categoryList.slice(0,6).map((item, index) => (

                    <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                        <CategoryCard
                            id={item.id}
                            onCategoryClick={(id:number) =>{
                                navigate("/sub-category-list/"+id)
                            }}
                            key={index}
                            icon={item.icon}
                            title={item.name}

                        />
                    </Col>

                ))}
            </Flex>

        </Flex>

    );
};

export default connect(null, {getProductCategoryList})(withRouter(CategoryList));
